/* iter327 — Document Code Edit Modal (Admin / System Authority only).
 *
 * Metadata-only update.  R2 original file, revision history, revision binaries
 * are NEVER touched — see PUT /api/gmp/master-documents/{mid}/document-code.
 */
import React, { useState } from "react";
import { api } from "@/lib/api";
import { Modal, Btn, Input, Textarea } from "@/components/UI";
import { Loader2, FileCode } from "lucide-react";

export default function DocCodeEditModal({ open, onClose, doc, onSaved }) {
  const current = doc?.base_code || "";
  const [newCode, setNewCode] = useState(current);
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  React.useEffect(() => {
    if (open) { setNewCode(current); setReason(""); setErr(""); }
  }, [open, current]);

  const submit = async () => {
    const trimmed = (newCode || "").trim();
    if (!trimmed) { setErr("Yeni kod zorunlu"); return; }
    if (trimmed === current) { setErr("Yeni kod mevcut kod ile aynı"); return; }
    setBusy(true); setErr("");
    try {
      const r = await api.put(`/gmp/master-documents/${doc.id}/document-code`,
        { new_code: trimmed, reason: reason || null });
      onSaved?.(r);
      onClose?.();
    } catch (e) {
      const d = e?.response?.data?.detail;
      setErr(typeof d === "string" ? d : (d?.message || "Değişiklik başarısız"));
    } finally { setBusy(false); }
  };

  return (
    <Modal open={open} onClose={onClose} title="Doküman Kodunu Düzenle" size="md">
      <div className="space-y-3" data-testid="doc-code-edit-modal">
        <div className="bg-slate-50 border rounded p-2 text-xs">
          <div className="font-semibold">{doc?.title}</div>
          <div className="text-slate-500">
            Mevcut kod: <span className="font-mono">{doc?.current_full_code || doc?.base_code}</span>
          </div>
        </div>
        <Input label="Yeni Doküman Kodu *" value={newCode}
                onChange={e => setNewCode(e.target.value)}
                placeholder={current.replace(/\d+/, "nn")}
                data-testid="doc-code-new"/>
        <div className="text-[10px] text-slate-500">
          Format: <code>T18/KYB</code> veya <code>SOP05/KYB</code>. Revizyon
          soneki (/00) opsiyonel — tüm revizyonların kodu otomatik güncellenir.
          Yüklenen orijinal PDF dosyalarına dokunulmaz.
        </div>
        <Textarea label="Değişiklik Gerekçesi" rows={2} value={reason}
                   onChange={e => setReason(e.target.value)}
                   data-testid="doc-code-reason"/>
        {err && (
          <div className="bg-red-50 border border-red-300 rounded p-2 text-xs text-red-800"
                data-testid="doc-code-err">{err}</div>
        )}
        <div className="flex justify-end gap-2 pt-2 border-t">
          <Btn variant="secondary" onClick={onClose} disabled={busy}>Vazgeç</Btn>
          <Btn onClick={submit} disabled={busy || !newCode.trim()}
                data-testid="doc-code-save">
            {busy
              ? <><Loader2 size={12} className="animate-spin inline mr-1"/>Kaydediliyor…</>
              : <><FileCode size={12} className="inline mr-1"/>Kodu Güncelle</>}
          </Btn>
        </div>
      </div>
    </Modal>
  );
}
